var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isSiteLoadDone && _vm.bodyBuilderFooterOfferList.length > 0
        ? _c(
            "div",
            { staticClass: "ui-content" },
            [
              _c("candy-bar", {
                attrs: {
                  title: _vm.$t("shopbuilder_offers"),
                  "product-list": _vm.bodyBuilderFooterOfferList
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSiteLoadDone
        ? [
            _vm.footer.topLeftText !== "" || _vm.footer.topRightText !== ""
              ? _c(
                  "div",
                  { staticClass: "d-flex flex-wrap footer-top-text-row" },
                  [
                    _c("div", {
                      staticClass: "col-6 footer-top-text-col",
                      domProps: { innerHTML: _vm._s(_vm.footer.topLeftText) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-6 footer-top-text-col",
                      domProps: { innerHTML: _vm._s(_vm.footer.topRightText) }
                    })
                  ]
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSiteLoadDone && _vm.isFooterExists
        ? _c("div", { staticClass: "footer-wrapper" }, [
            _c("div", { staticClass: "container-xl" }, [
              _c("div", {
                staticClass: "text-center slogen-text text-uppercase",
                domProps: { textContent: _vm._s(_vm.footer.slogen) }
              }),
              _vm._v(" "),
              _vm.footer.isMailSubscriberVisible
                ? _c("div", { staticClass: "row mb-5" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 d-flex justify-content-center" },
                      [
                        _c("news-letter-subscribe-widget", {
                          attrs: {
                            "is-default-open": _vm.footer.isEmailBoxDefaultOpen
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "main-menu-wrapper col-12 col-lg-4" },
                  [
                    _vm.footer.leftItemList.length !== 0
                      ? [
                          _c(
                            "ul",
                            _vm._l(_vm.footer.leftItemList, function(
                              footerItem
                            ) {
                              return _c(
                                "li",
                                {
                                  key: footerItem.id,
                                  staticClass: "footer-list-item"
                                },
                                [
                                  footerItem.isOuterLink ||
                                  footerItem.isPhoneNumber ||
                                  footerItem.isEmail
                                    ? _c("a", {
                                        attrs: {
                                          href: footerItem.link,
                                          rel: footerItem.isNoFollow
                                            ? ""
                                            : "nofollow",
                                          target: footerItem.isOuterLink
                                            ? "_blank"
                                            : "_self"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                    : footerItem.link !== null
                                    ? _c("router-link", {
                                        attrs: { to: footerItem.link },
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "main-menu-wrapper col-12 col-lg-4" },
                  [
                    _vm.footer.middleItemList.length !== 0
                      ? [
                          _c(
                            "ul",
                            _vm._l(_vm.footer.middleItemList, function(
                              footerItem
                            ) {
                              return _c(
                                "li",
                                {
                                  key: footerItem.id,
                                  staticClass: "footer-list-item"
                                },
                                [
                                  footerItem.isOuterLink ||
                                  footerItem.isPhoneNumber ||
                                  footerItem.isEmail
                                    ? _c("a", {
                                        attrs: {
                                          href: footerItem.link,
                                          rel: footerItem.isNoFollow
                                            ? ""
                                            : "nofollow",
                                          target: footerItem.isOuterLink
                                            ? "_blank"
                                            : "_self"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                    : footerItem.link !== null
                                    ? _c("router-link", {
                                        attrs: { to: footerItem.link },
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "main-menu-wrapper col-12 col-lg-4" },
                  [
                    _vm.footer.rightItemList.length !== 0
                      ? [
                          _c(
                            "ul",
                            _vm._l(_vm.footer.rightItemList, function(
                              footerItem
                            ) {
                              return _c(
                                "li",
                                {
                                  key: footerItem.id,
                                  staticClass: "footer-list-item"
                                },
                                [
                                  footerItem.isOuterLink ||
                                  footerItem.isPhoneNumber
                                    ? _c("a", {
                                        attrs: {
                                          href: footerItem.link,
                                          rel: footerItem.isNoFollow
                                            ? ""
                                            : "nofollow",
                                          target: footerItem.isOuterLink
                                            ? "_blank"
                                            : "_self"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                    : footerItem.link !== null
                                    ? _c("router-link", {
                                        attrs: { to: footerItem.link },
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(footerItem.name)
                                        }
                                      })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.footer.isShopFinderActive ? _c("shop-finder") : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.footer.socialItemList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-center w-100 my-3"
                      },
                      _vm._l(_vm.footer.socialItemList, function(
                        socialIcon,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: "social-" + socialIcon.name + "-" + index },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: socialIcon.link,
                                  title: socialIcon.name,
                                  target: "_blank"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sendSocialGaEvent(
                                      socialIcon.contentType
                                    )
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  class: "social-icon " + socialIcon.contentType
                                })
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row social-bottom-wrapper w-100" }, [
                  _c("div", {
                    staticClass:
                      "col-12 col-lg-6 d-flex d-lg-block justify-content-center bottom-text",
                    domProps: { innerHTML: _vm._s(_vm.footer.bottomLeftText) }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "col-12 col-lg-6 d-flex text-center text-lg-right d-lg-block justify-content-center bottom-text",
                    domProps: { innerHTML: _vm._s(_vm.footer.bottomRightText) }
                  })
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover.left",
              value: _vm.$t("ugras_a_lap_tetejere"),
              expression: "$t('ugras_a_lap_tetejere')",
              modifiers: { hover: true, left: true }
            }
          ],
          staticClass: "btn btn-primary up-btn btn-lg back-to-top",
          attrs: {
            id: "back-to-top",
            to: _vm.$route.fullPath,
            "aria-label": _vm.$t("ugras_a_lap_tetejere")
          },
          nativeOn: {
            click: function($event) {
              return _vm.scrollToTop($event)
            }
          }
        },
        [
          _c("div", { staticClass: "pt-2 pb-1" }, [
            _c("div", {
              staticClass: "icon-arrow arrow-up mt-1",
              attrs: { "aria-hidden": "true" }
            })
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }